import { IonContent, IonPage } from "@ionic/react";
import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router";
import DonateComponent from "../../components/DonateComponent";
import Footer from "../../components/Footer";
import { User } from "../../models/data";
import { fetchUserCredit } from "../../services/donate_service";

interface  Props {
    user:User
}

const Donate: React.FC<Props> = ({user}) => {

    const { name } = useParams<{ name: string; }>();

    /**state information transfer by donate DonateFundraiser.tsx */
    const state:any=useLocation().state;
    
    /**component states*/
    const [accountCredit, setAccountCredit] = useState((): string | number | null => 'loading');
    
    /**on component loaded */
    useEffect(() => {
        fetchData();
        return () => {};
    },[])

    /**fetchdate() */
    const fetchData = async () => {
        let data = await fetchUserCredit(user.id);
        if (data.message) {
            setAccountCredit(() => {
                return 5
            })
        } else {
            setAccountCredit(() => {
                return null
            })
        }
    }

    return (
        <IonPage className="viewContainer">
            <IonContent>
            <DonateComponent method={name} stateData={state} user={user} accountCredit={accountCredit}></DonateComponent>
            <Footer></Footer>
            </IonContent>
        </IonPage >
    );
}

export default Donate;